import React, { ReactElement } from "react";
import { Loading } from "../loading/Loading";
import { SummaryData } from "../../types/SummaryData";
import { useQuery } from "react-query";
import { showRequestErrorToast } from "../../services/ErrorService";
import DataRequest from "../../queries/DataRequest";
import { Summary as ReportSummary } from "@idwal/idwal-react-components";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { AppContext } from "../../App";
import { AppContextType } from "../../types/AppContextType";
import { useLocation, useParams } from "react-router-dom";
import { getPhotos } from "../../queries/photosQueries";
import { LoadingShipImage } from "../loading/LoadingShipImage";
import { getVesselInspectionData } from "../../queries/particularsQueries";
import { canShowDataSharingOptIn } from "../../utils/dataSharingHelpers";
import { DataSharingStatus } from "../../constants/DataSharingConstants";
import { VesselInspectionResponse } from "../../types/responses/VesselInspectionResponse";
import "./Summary.css";

export const Summary = ({ 
    documentData,
    vesselInspectionResponse,
    dataSharingStatusOverride
}: { 
    documentData: any;
    vesselInspectionResponse?: VesselInspectionResponse;
    dataSharingStatusOverride?: DataSharingStatus | null;
}): ReactElement => {
    const { inspectionId } = useParams();
    const { user } = useAuthenticator((context) => [context.authStatus, context.user]);
    const { earlyRelease, restrictedView } = React.useContext(AppContext) as AppContextType;

    const locationSearch = useLocation();
    const queryParams = new URLSearchParams(locationSearch.search);
    const section = queryParams.get("section");
    const { data: vesselData } = getVesselInspectionData(inspectionId ?? "", user);
    const { data: photoData, isLoading } = getPhotos(inspectionId ?? "", user);

    if (!inspectionId) {
        showRequestErrorToast("summary (id)");
    }

    const { error, data } = useQuery<SummaryData>(
        ["summary"],
        () => DataRequest(inspectionId ?? "", "summary", user)
    );

    if (error) {
        showRequestErrorToast("Summary");
        return <div></div>;
    }

    if (isLoading || !photoData) {
        return <LoadingShipImage />;
    }

    const disableGallery = canShowDataSharingOptIn(
        dataSharingStatusOverride,
        vesselInspectionResponse?.dataSharingAvailable,
        vesselInspectionResponse?.InspectionTypeShortName
    );

    if (data && documentData) {
        if (earlyRelease) {
            data.paragraph = "";
        }

        return (
            <ReportSummary
                paragraph={data.paragraph}
                photoData={photoData.filter((a) => a.isDefault)}
                documentData={documentData}
                section={section}
                restrictedView={restrictedView}
                earlyRelease={vesselData?.earlyRelease}
                disableGallery={disableGallery}
            />
        );
    }

    return <Loading />;
};